export const VIEW_SIZE = 24;
export const VIEW_BOX = `0 0 ${VIEW_SIZE} ${VIEW_SIZE}`;
